import { useState, useEffect } from 'react'
import { projectAPI } from '../../../api';

import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { ModelsModal } from './ModelsModal';
import { TagsInput } from "react-tag-input-component";
import { Modal } from '../../../components/Modal'
import toastr from 'toastr'
import { RateLimitModelType } from '../../../models';

interface Props {
    project: any,
    defaultSettingProject?: any,
    setProject: (project: any) => void
}

const updateSetting = async (setProject: (project:any) => void, project:any, type: string, attribute_name: string, attribute_value: boolean | string | number | undefined, showToast: boolean = false, attribute_sub_value: string | undefined = undefined) => {
  await projectAPI.updateSetting(project.id, type, {'attribute_name': type != 'content' ? attribute_name.replace('response_','').replace('prompt_','') : attribute_name, 'attribute_value': attribute_value, 'attribute_sub_value': attribute_sub_value})
  showToast && toastr.info('Updated')
  if( type === 'rate_limit' ){
    if (attribute_value === undefined) {
      const { [attribute_name]: _, ...updatedRateLimit } = project.api_access_rate_limit;
      setProject({ ...project, api_access_rate_limit: updatedRateLimit });
    } else {
      setProject({ ...project, api_access_rate_limit: { ...project.api_access_rate_limit, [attribute_name]: {
        'value': attribute_value === '' ? null : attribute_value,
        'unit': attribute_sub_value
      }}});
    }
  }else{
    setProject({ ...project, [attribute_name]: attribute_value })
  }
}

const updateSettingCheckbox = (setProject: (project:any) => void, project:any, type: string, attribute_name: string) => {
  return <div className="form-check form-switch form-check-custom">
    <input 
      className="form-check-input h-20px w-30px" 
      type="checkbox" 
      checked={project[attribute_name]}
      disabled={attribute_name === 'classifier_driven_generation' && project.origin === project.id}
      onChange={() => {
        updateSetting(setProject, project, type, attribute_name, !project[attribute_name])
      }}
    />

    { type === 'content' && project.id !== project.origin && project.id !== 'default' && !project[`${attribute_name}_updated_by`] && 
      <div className="text-info ms-2">Currently default</div>
    }
  </div>
}

const UpdateRateLimit: React.FC<{
  setProject: (project: any) => void;
  project: any;
  defaultSettingProject?: any;
  model: string;
}> = ({setProject, project, defaultSettingProject, model}) => {
  const [value, setValue] = useState<number>();
  const [unit, setUnit] = useState<string>('minute');

  useEffect(() => {
    if( project.api_access_rate_limit?.[model] === undefined && defaultSettingProject.api_access_rate_limit?.[model] ){
      setValue(defaultSettingProject.api_access_rate_limit[model].value);
      setUnit(defaultSettingProject.api_access_rate_limit[model].unit);
    }else{
      setValue(project.api_access_rate_limit?.[model]?.value ?? '');
      setUnit(project.api_access_rate_limit?.[model]?.unit ?? 'minute');
    }
  }, [project.api_access_rate_limit])
  
  return <div className="d-flex flex-column mw-200px">
    <div className="d-flex align-items-center border border-gray-300 rounded mb-1">
      <input 
        type='number' 
        className="form-control border-0 form-control-transparent form-control-sm" 
        value={value}
        onChange={(e) => {
          setValue(parseInt(e.target.value));
        }}
      />
      <select 
        className="form-select form-select-sm border-0 w-150px form-control-transparent me-1"
        value={unit}
        onChange={(e) => {
          setUnit(e.target.value);
        }}
      >
        <option value="minute">per minute</option>
        <option value="hour">per hour</option>
        <option value="day">per day</option>
      </select>
    </div>

    {project.api_access_rate_limit?.[model]?.value === null && 
      <div className="text-info py-1">Currently unlimited</div>
    }
    {
      project.api_access_rate_limit?.[model] === undefined && 
      <div className="text-info py-1">Currently default rate limit</div>
    }
    <button 
      type='button' className='btn btn-light-dark btn-sm fs-8 px-2 py-1 mt-1' 
      onClick={() => {
        updateSetting(setProject, project, 'rate_limit', model, value ? value : '', true, unit);
      }}
      disabled={
        (value === (project.api_access_rate_limit?.[model] === undefined && defaultSettingProject ? defaultSettingProject.api_access_rate_limit[model]?.value : (project.api_access_rate_limit?.[model]?.value ?? '')))
        &&
        (unit === (project.api_access_rate_limit?.[model] === undefined && defaultSettingProject ? defaultSettingProject.api_access_rate_limit[model]?.unit : (project.api_access_rate_limit?.[model]?.unit ?? 'minute')))
      }
    >
      Update
    </button>
    {project.id !== 'default' &&
    <>
    {
      project.api_access_rate_limit?.[model] !== undefined &&
      <button type='button' className='btn btn-light-dark btn-sm fs-8 px-2 py-1 mt-1' onClick={() => {
        updateSetting(setProject, project, 'rate_limit', model, undefined, true);
      }}>
        Use default
      </button>
    }
    {project.api_access_rate_limit?.[model]?.value !== null && 
      <button type='button' className='btn btn-light-dark btn-sm fs-8 px-2 py-1 mt-1' onClick={() => {
        updateSetting(setProject, project, 'rate_limit', model, '', true);
      }}>
        Make unlimited
      </button>
    }
    </>
    }
  </div>
}

const UpdateSettingNumber: React.FC<{
  setProject: (project: any) => void;
  project: any;
  type: string;
  label: string;
  attribute_name: string;
  attribute_value: number;
}> = ({ setProject, project, type, label, attribute_name, attribute_value }) => {
  const [value, setValue] = useState<number>(attribute_value);

  return (
    <div className="d-flex flex-column">
      <label className="text-gray-800">{label}</label>
      <div className="d-flex align-items-center border border-gray-300 rounded mb-1">
        <input
          type="number"
          className="form-control border-0 form-control-transparent form-control-sm"
          value={value}
          onChange={(e) => {
            setValue(parseInt(e.target.value));
          }}
        />
      </div>
      <button
        type="button"
        className="btn btn-light-dark btn-sm fs-8 px-2 py-1"
        onClick={() => {
          updateSetting(setProject, project, type, attribute_name, value, true);
        }}
        disabled={value === attribute_value}
      >
        Update
      </button>
    </div>
  );
};

const TriggeringTerms = ({setProject, project, type, attribute_name, attribute_value = ""}: {
  setProject: (project: any) => void;
  project: any;
  type: string;
  attribute_name: string;
  attribute_value?: string;
}) => {
  const [showModal, setShowModal] = useState<boolean>(false)
  const [terms, setTerms] = useState<string[]>(attribute_value ? attribute_value.split(',').map(keyword => keyword.trim()) : [])
  return (
    <div className="mt-1">
      <button className="btn btn-primary btn-sm fs-8 px-2 py-1" onClick={() => {
        setShowModal(true)
      }}>Manage Triggering Terms</button>
      <Modal show={showModal} handleClose={()=>setShowModal(false)} dialogClassName="" title="Manage Triggering Terms">
        <TagsInput
          value={terms}
          onChange={setTerms}
          placeHolder={`Enter triggering terms`}
        />
        <button className="btn btn-light-dark btn-sm fs-8 px-2 py-1 mt-1 me-1" onClick={() => {
          setTerms([])
        }}>Clear</button>
        <button className="btn btn-primary btn-sm fs-8 px-2 py-1 mt-1" onClick={() => {
          updateSetting(setProject, project, type, attribute_name, terms.join(','), true)
        }}>Update</button>
      </Modal>
    </div>
  )
}

const SettingCheckbox = ({setProject, project, type, attribute_name, label, tooltip}: {
  setProject: (project: any) => void;
  project: any;
  type: string;
  attribute_name: string;
  label: string;
  tooltip?: string;
}) => {
  return <div className="col-lg-3 col-xl-2" key={attribute_name}>
    <div className="border border-gray-400 rounded p-3">
      <div className="fs-6 fw-semibold">
        {label}
        {tooltip && 
          <OverlayTrigger
            placement="top"
            container={document.body}
            overlay={
              <Tooltip id={`${attribute_name}`}>
                {tooltip}
              </Tooltip>
            }
          >
            <i className="fa-solid fa-info-circle fs-7 ms-1 pe-0"></i>
          </OverlayTrigger>
        }
      </div>
      {updateSettingCheckbox(setProject, project, type, attribute_name)}
    </div>
  </div>
}

const ContentFeatureSettings : React.FC<Props> = ({project, defaultSettingProject, setProject}) => {

  const [showModelsModal, setShowModelsModal] = useState<boolean>(false)

  const isDefault = project.origin == project.id
  const isDefaultSetting = project.id === 'default'

  return <>
    {isDefault && 
    <>
      <div className="row">
        <div className={`col-lg-2`}>
          <div className="fs-6 fw-semibold">Default Parameters</div>
        </div>
        <div className={`col-lg-2`}>
            <button className="btn btn-light-dark btn-sm fs-8 px-2 py-1" onClick={() => {
              setShowModelsModal(true)
            }}>Manage</button>
        </div>
      </div>
      <div className="separator mt-7 mb-5"></div>
    </>
    }
    <div className="row g-2">
      <div className="col-lg-12 mb-2">
        <div className="fs-6 fw-bolder">Prompt handling 
          <OverlayTrigger
            placement="top"
            container={document.body}
            overlay={
              <Tooltip id="prompt-handling">
                This setting affects how prompts are handled during chat completions.
              </Tooltip>
            }
          >
            <i className="fa-solid fa-info-circle fs-7 ms-1 pe-0"></i>
          </OverlayTrigger>
        </div>
      </div>
      {[
        ["prompt_intervention", "For tailored responses. The prompt's embedding is matched against the database, and if similarity exceeds the threshold, the matched response is used. Applies to all chat completions except image understanding."],
        ["prompt_blocklist_filter", "To intercept prompts or keywords that are blocked. This will result in a filtered content error being returned."],
        ["prompt_safety_filter", "To identify and block unsafe prompts using Gemma's instruction-based classification. If a prompt is deemed unsafe, a filtered content error will be returned."],
        project.classifier_driven_generation && ["prompt_rephrasing", "Exclusively to the Fanar model for directing prompts to RAGs. The rephrased prompt will be used to query the RAGs. Otherwise, the original prompt will be utilized."]
      ].filter(Boolean).map(([attribute_name, tooltip]) => (
        <SettingCheckbox
          setProject={setProject}
          project={project}
          type="content"
          attribute_name={attribute_name}
          label={attribute_name.replace('prompt_', '').replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}
          tooltip={tooltip}
        />
      ))}

      <div className="separator mt-7 mb-5"></div>
      
      <div className="col-lg-12 mb-2">
          <div className="fs-6 fw-bolder">Content Generation</div>
      </div>
      {[
        ["classifier_driven_generation", "Fanar", "Enables classifier-driven generation, allowing the Orchestrator to route prompts to the appropriate models or services based on classification."],
        ["deep_thinking", "Deep Thinking", "Enables thinking capabilities for more complex reasoning tasks."],
        project.classifier_driven_generation && ["recency_rag", "Recency RAG", "Enables retrieval-augmented generation for recent content."],
        project.classifier_driven_generation && ["biography_rag", "Biography RAG", "Enables retrieval-augmented generation for biographical content."],
        project.classifier_driven_generation && ["poem", "Poem", "Enables poem generation capabilities."],
        ["islamic_rag", "Islamic RAG", "Enables retrieval-augmented generation for Islamic content."],
        ["image_understanding", "Image Understanding", "Enables understanding of images."],
        ["video_understanding", "Video Understanding", "Enables understanding of videos."],
        !isDefault && ["text_to_speech", "Text To Speech", "Enables text-to-speech capabilities."],
        !isDefault && ["speech_to_text", "Speech To Text", "Enables speech-to-text capabilities."],
        !isDefault && ["transcription", "Transcription", "Enables transcription capabilities."],
        !isDefault && ["image_generation", "Image Generation", "Enables image generation capabilities."],
        !isDefault && ["translation", "Translation", "Enables translation capabilities."]
      ].filter(Boolean).map(([attribute_name, label, tooltip]) => (
        <SettingCheckbox
          setProject={setProject}
          project={project}
          type="content"
          attribute_name={attribute_name}
          label={label}
          tooltip={tooltip}
        />
      ))}

      {!isDefault && 
      <>
        <div className="separator mt-7 mb-5"></div>
        <div className="col-lg-12 mb-2">
          <div className="fs-6 fw-bolder">
            Rate limits
            <OverlayTrigger
              key="api-rate-limit"
              placement="top"
              container={document.body}
              overlay={
                <Tooltip id="api-rate-limit">
                  Specifies the maximum number of requests allowed per minute.
                </Tooltip>
              }
            >
              <i className="fa-solid fa-info-circle fs-7 ms-2"></i>
            </OverlayTrigger>
          </div>
        </div>
        {
          [
            (isDefaultSetting || project.classifier_driven_generation) && RateLimitModelType.FANAR,
            RateLimitModelType.FANAR_C_1_87B,
            RateLimitModelType.FANAR_S_1_7B,
            (isDefaultSetting || project.islamic_rag) && RateLimitModelType.ISLAMIC_RAG,
            (isDefaultSetting || project.image_understanding || project.video_understanding) && RateLimitModelType.FANAR_ORYX_IVU_1,
            (isDefaultSetting || project.text_to_speech) && RateLimitModelType.FANAR_AURA_TTS_1,
            (isDefaultSetting || project.speech_to_text) && RateLimitModelType.FANAR_AURA_STT_1,
            (isDefaultSetting || project.transcription) && RateLimitModelType.FANAR_AURA_STT_LF_1,
            (isDefaultSetting || project.image_generation) && RateLimitModelType.FANAR_IMAGE_GEN_1,
            (isDefaultSetting || project.translation) && RateLimitModelType.FANAR_SHAHEEN_MT_1
          ].filter(Boolean).map((model) => (
            <div className="col-lg-3 col-xl-2" key={model}>
              <div className="border border-gray-400 rounded p-3">
                <div className="fs-6 fw-semibold">
                  {model}
                </div>
                <UpdateRateLimit setProject={setProject} project={project} defaultSettingProject={defaultSettingProject} model={model}/>
              </div>
            </div>
          ))
        }
      </>
      }

      <div className="separator mt-7 mb-5"></div>
      <div className="col-lg-12 mb-2">
        <div className="fs-6 fw-bolder">
          Response handling
          <OverlayTrigger
            placement="top"
            container={document.body}
            overlay={
              <Tooltip id="response-handling">
                This setting affects how responses are handled during chat completions.
              </Tooltip>
            }
          >
            <i className="fa-solid fa-info-circle fs-7 ms-1 pe-0"></i>
          </OverlayTrigger>
        </div>
      </div>
      {
        [
          isDefault && ["attribution", "Enables attribution for responses"],
          ["response_blocklist_filter", "To intercept responses or keywords that are blocked. This will result in a filtered content error being returned."],
          ["response_safety_filter", "Checks prompt-response pairs from non-RAG and non-poem models using a pre-trained model; blocks unsafe content with a filtered error."],
          ["response_quran_validator", "Ensures Quran tags in responses are correct. Returns the original or corrected response based on validation."]
        ].filter((item): item is [string, string] => Array.isArray(item)).map(([attribute_name, tooltip]) => (
          <SettingCheckbox
            setProject={setProject}
            project={project}
            type="content"
            attribute_name={attribute_name}
            label={attribute_name.replace('response_', '').replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}
            tooltip={tooltip}
          />
        ))
      }
    </div>
    {isDefault && 
      <>
      <div className="separator mt-7 mb-5"></div>
      <div className="row g-2">
        <div className="col-lg-12 mb-2">
          <div className="fs-6 fw-bolder">Prompt Features</div>
        </div>
        {
          [
            project.deep_thinking && ["prompt_deep_thinking","Thinking", false],
            ["prompt_speech_to_text", "Speech to Text", false],
            ["prompt_transcription", "Transcription", true],
            ["prompt_text_to_speech", "Text to Speech", false],
            ["prompt_image_generation", "Image Generation", false],
            project.image_understanding && ["prompt_image_understanding", "Image Understanding", true],
            project.video_understanding && ["prompt_video_understanding", "Video Understanding", true],
            ["prompt_image_search", "Image Search", false],
            ["prompt_music_generation", "Music Generation", false],
            ["prompt_translate", "Translate", false],
          ].filter(Boolean).map(([attribute_name, label, withFiles]) => (
            <div className="col-lg-3 col-xl-2" key={attribute_name}>
              <div className="border border-gray-400 rounded p-3">
                <div className="fs-6 fw-semibold">{label}</div>
                {updateSettingCheckbox(setProject, project, 'prompt', attribute_name)}
                {withFiles && project[`${attribute_name}`] &&
                  <div className="d-flex flex-row gap-2 mt-2">
                    <UpdateSettingNumber
                      setProject={setProject}
                      project={project}
                      label={'Max Files'}
                      type='prompt'
                      attribute_name={`${attribute_name}_max_files`}
                      attribute_value={project[`${attribute_name}_max_files`]}
                    />
                    <UpdateSettingNumber
                      setProject={setProject}
                      project={project}
                      label={'Max File Size (MB)'}
                      type='prompt'
                      attribute_name={`${attribute_name}_max_file_size`}
                      attribute_value={project[`${attribute_name}_max_file_size`]}
                    />
                  </div>
                }
                { attribute_name === 'prompt_image_generation' && project[`${attribute_name}`] &&
                  <>
                    <TriggeringTerms
                      setProject={setProject}
                      project={project}
                      type='prompt'
                      attribute_name='prompt_image_generation_triggering_terms'
                      attribute_value={project.prompt_image_generation_triggering_terms}
                    />
                    <div className="mt-2">
                      <div className="fs-6 fw-semibold text-gray-800">Prompt Classification</div>
                      {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_image_generation_classification')}
                    </div>
                    <div className="mt-2">
                      <div className="fs-6 fw-semibold text-gray-800">Prompt Rephrasing</div>
                      {updateSettingCheckbox(setProject, project, 'prompt', 'prompt_image_generation_rephrasing')}
                    </div>
                  </>
                }
              </div>
            </div>
          ))
        }
      </div>
      <div className="separator mt-7 mb-5"></div>
      <div className="row g-2">
        <div className="col-lg-12 mb-2">
          <div className="fs-6 fw-bolder">Response Features</div>
        </div>
        {
          [
            ["response_reaction", null],
            ["response_regenerate", "This setting allows users to regenerate the last response."],
            ["response_text_to_speech", null],
            ["response_image_generation", null],
            ["response_image_search", null],
            ["response_music_generation", null],
            ["response_translate", null]
          ].map(([attribute_name, tooltip]) => (
            attribute_name && (
              <SettingCheckbox
                setProject={setProject}
                project={project}
                type="response"
                attribute_name={attribute_name}
                label={attribute_name.replace('response_', '').replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())}
                tooltip={tooltip || undefined}
              />
            )
          ))
        }
      </div>
      </>
      }
      <ModelsModal show={showModelsModal} projectId={project.id} name={project.name} handleClose={() => {
        setShowModelsModal(false)
      }}/>
  </>
}


export {ContentFeatureSettings, updateSettingCheckbox, updateSetting}